export const insightsCalls = ({ child }) => {
  child.call('removeElement', {
    querySelector: 'pjis-menu-dashboards',
  });

  child.call('globalStyles', {
    styles:
      'div.max-height.master-container{height: 100%}; .service-toolbar-buttons{display: none;} #frmGenericObject{overflow:hidden;}html, body {max-height: calc(100% - 1px);} .variable-flex-content.card{margin-bottom: 0px;} .saveFooterContainer{padding-top: 20px;} pjis-menu-dashboards{display:none;} .locator-Settings{display: none;}',
    id: 'irs-globalstyles',
  });
};
